<div class="container card positionCard">
  <div class="row">
      <!--  <div class="col-md-6 col-sm-10 center-block text-center">
              <div class="page-head">We need your sign-off </div>
          </div> -->
  </div>
  <div class="row">
      <div class="col-md-6 col-sm-10 col-md-push-3 tablet-block">

          <div class="clearfix no-gutter-sm content-block head-padding">
              <div class="row">
                  <div class="col-xs-12 text-center">
                      <div class="subhead-header">Provide your consent by Digitally signing
                          <br>these documents</div>
                  </div> 
              </div>
              
              <div class="col-sm-11 center-block" *ngIf="isLinkExpired">
                <div class="content-holder e-link-err">
                    <h4 class="text-grey text-center text-xs-center"><strong>Link is expired</strong></h4>
                </div>
              </div>

              <div class="col-sm-11 center-block" *ngIf="isError">
                <div class="content-holder e-link-err">
                    <h4 class="text-grey text-center text-xs-center"><strong>{{customError}}</strong></h4>
                </div>
              </div>
              <div class="col-sm-11 center-block" *ngIf="!isLinkExpired && !isError">
                  <div class="content-holder">
                      <h4 class="text-grey text-xs-center"><strong>eSign Your Application and Terms & Conditions</strong></h4>
                  </div>
                  <ul class="document-list">
                      <li *ngFor="let document of DocumentList">
                          <div class="docList">
                            <div class="data disp-ib">{{document.name}}</div>
                            <a (click)="downloadEsignDocument(document)" *ngIf="document.url"><div class="downloadIcon pull-right"></div></a>
                        </div>

                          <!-- <span class="data">{{document.name}}</span>
                          <a (click)="downloadEsignDocument()"><span class="downloadIconText" >Download Documents</span></a> -->
                          
                      </li>
                  </ul>
                  <div class="row content-holder">
                      <div class="col-xs-12 col-sm-12 text-center">
                          <button id="esignDocListOne_next" type="button" class="btn text-center"
                              (click)="sendToOtp()" data-toggle="modal"
                              [attr.data-target]="DocumentPreviewPopUpData.Id" [disabled]=" ShowBackLoader || disable_preview_eSign">Proceed to E-Sign</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<!--(onClose)="GoToEsign($event)" -->
<custom-popup [config]="Config" [title]="'E sign documents preview'" [subtitle]="'Consolidated Doc'" [showClose]="true"
  [id]="DocumentPreviewPopUpData.Id" [config]="DocumentPreviewPopUpData.Config" (onClose)="hidePopUp($event)">
  <div class="modal-body">
      <div class="row">
          <div class="col-xs-12">
          </div>
      </div>
  </div>
  <div class="modal-footer">
      <div class="clearfix Next-actionButton row top-margin">
          <div class="col-xs-8 center-block">
              <button type="button" class="btn btn-primary btn-block" (click)="hidePopUp($event)"
                  data-dismiss="modal" id="esignDocListTwo_next" [disabled]="ShowLoader">Proceed and eSign
                  <img class="btn-loader" *ngIf="ShowLoader" src="assets/img/loader_orange.gif" />
              </button>
          </div>
      </div>
  </div>
</custom-popup>

<custom-popup [subtitle]="''" [title]="'eSign your documents for faster disbursement'" [config]="config" [id]="EsignDetailsPopUpData.Id"
  [config]="EsignDetailsPopUpData.Config">
  <div class="modal-body form-group">
      <div class="row">
          <div class="col-sm-11 col-xs-11 center-block fontFamily">
              <h3>What is eSign?</h3>
              <p *ngIf="!ExistingCust">eSign is a technology launched under the Digital India initiative of
                  Government of India that allows Aadhaar
                  holders to sign any document remotely. A convenient and safe alternative to physical
                  signatures/digital
                  signature certificate.</p>
              <p *ngIf="ExistingCust">eSign is a process which allows you to remotely sign any document through an
                  OTP sent to your mobile. It
                  is a convenient and safe alternative to physical signature.</p>
          </div>
      </div>
      <div class="row">
          <div class="col-sm-11 col-xs-11 center-block fontFamily">
              <h3>Benefits of eSign:</h3>
              <p>
                  <img class="icon-style" src="assets/img/svg/icon-next_arrow.svg" />
                  <span>Save time – Get money faster into your account</span>
              </p>
              <p>
                  <img class="icon-style" src="assets/img/svg/icon-next_arrow.svg" />
                  <span>Completely secure – The process is encrypted, thus safe</span>
              </p>
              <p>
                  <img class="icon-style" src="assets/img/svg/icon-next_arrow.svg" />
                  <span>Risk free - Data cannot be leaked or misused by anyone</span>
              </p>
              <p>
                  <img class="icon-style" src="assets/img/svg/icon-next_arrow.svg" />
                  <span>Legally valid – Recognised by the Government of India</span>
              </p>
          </div>
      </div>
      <div class="row">
          <div class="col-sm-11 col-xs-11 center-block fontFamily">
              <h3>How eSign works?</h3>
              <ol>
                  <li>Upload/preview document to be eSigned</li>
                  <li *ngIf="!ExistingCust">Enter your Aadhaar number </li>
                  <li>Enter the OTP received on your registered mobile number and you are done!</li>
              </ol>
          </div>
      </div>
      <div class="row top-margin">
          <div class="col-sm-11 col-xs-11 center-block fontFamily">
                  <p>Disclaimer: Bajaj Finance Ltd. reserves the right to process or decline the application even after agreement eSign basis authenticity of details provided in application and documents and credit checks</p>
          </div>
      </div>

  </div>
  <div class="modal-footer row top-margin">
      <div class="col-sm-11 col-xs-11 center-block text-center">
          <button type="button" class="btn" id="esignDocListThree_next" (click)="hidePopUp($event);"
              [attr.data-target]="EsignDetailsPopUpData.Id">Okay, I got it</button>
      </div>
  </div>

</custom-popup>